import { useState, useEffect, useCallback } from 'react';
import { base44 } from '@/api/base44Client';

const STORAGE_KEY = 'vt_favorites';
const EVENT = 'vt-favorites-change';

function read() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch { return []; }
}
function write(ids) {
  const clean = [...new Set(ids.filter(Boolean))];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(clean));
  window.dispatchEvent(new CustomEvent(EVENT));
  return clean;
}
async function sync(ids) {
  try {
    const user = await base44.auth.me();
    if (!user) return ids;
    const merged = [...new Set([...(user.favorite_product_ids || []), ...ids])];
    if (JSON.stringify(merged) !== JSON.stringify(user.favorite_product_ids || [])) {
      await base44.auth.updateMe({ favorite_product_ids: merged });
    }
    return write(merged);
  } catch { return ids; }
}

export function toggleFavorite(id) {
  const current = read();
  const next = write(current.includes(id) ? current.filter((f) => f !== id) : [...current, id]);
  base44.auth.me().then((user) => user && base44.auth.updateMe({ favorite_product_ids: next })).catch(() => {});
}

export function useFavorites() {
  const [favorites, setFavorites] = useState(read());
  useEffect(() => {
    let active = true;
    sync(read()).then((ids) => active && setFavorites(ids));
    const handler = () => setFavorites(read());
    window.addEventListener(EVENT, handler);
    window.addEventListener('storage', handler);
    return () => { active = false; window.removeEventListener(EVENT, handler); window.removeEventListener('storage', handler); };
  }, []);
  const isFavorite = useCallback((id) => favorites.includes(id), [favorites]);
  return { favorites, isFavorite, toggleFavorite };
}
